import { render, staticRenderFns } from "./GateMonitor.vue?vue&type=template&id=1527783f&scoped=true&"
import script from "./GateMonitor.vue?vue&type=script&lang=js&"
export * from "./GateMonitor.vue?vue&type=script&lang=js&"
import style0 from "./GateMonitor.vue?vue&type=style&index=0&id=1527783f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1527783f",
  null
  
)

export default component.exports